import {
    SHOW_ALERT, 
    HIDE_ALERT
} from "../constants/AlertsConstants.js"


const initialState = {
    showAlert: false,
    message: "",
    alertType: "success"
}

export const alert = (state = initialState, action = {}) => {
  switch (action.type) {
      case SHOW_ALERT:
        return Object.assign({}, state, { 
            showAlert: true,
            message: action.payload.message,
            alertType: action.payload.alertType
        })
      case HIDE_ALERT:
        return Object.assign({}, state, {
            showAlert: false,
            message: "",
            alertType: "success"
        })
      default:
        return state
  }
  
}

export default alert
